"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Employee = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const user_1 = require("./user");
const look_up_entity_1 = require("./look-up.entity");
const department_entity_1 = require("../../../../service-lib/src/lib/entities/department.entity");
const designation_entity_1 = require("../../../../service-lib/src/lib/entities/designation.entity");
const organisation_entity_1 = require("../../../../service-lib/src/lib/entities/organisation.entity");
const org_vertical_entity_1 = require("./org-vertical.entity");
const org_branch_entity_1 = require("./org-branch.entity");
const user_role_entity_1 = require("./user-role.entity");
let Employee = class Employee {
    constructor(partial) {
        Object.assign(this, partial);
    }
};
exports.Employee = Employee;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "employeeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "salutation_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "salutationLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "first_name", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], Employee.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "last_name", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], Employee.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "email_id", unique: true, type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], Employee.prototype, "emailId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mobile", unique: true, type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], Employee.prototype, "mobile", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "user_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "userId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "branch_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "vertical_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "verticalId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "department_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "departmentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "designation_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "designationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "organisation_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "organisationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "iirm_emp_id", type: "varchar", unique: true }),
    tslib_1.__metadata("design:type", String)
], Employee.prototype, "iirmEmpId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "reporting_user_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "reportingUserId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "reporting_manager_employee_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "reportingManagerEmployeeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamp",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Employee.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamp",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Employee.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Employee.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamp", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Employee.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => user_1.User),
    (0, typeorm_1.JoinColumn)({ name: "user_id" }),
    tslib_1.__metadata("design:type", Object)
], Employee.prototype, "user", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => Employee, (employee) => employee.reportees, {
        nullable: true,
    }),
    (0, typeorm_1.JoinColumn)({ name: "reporting_manager_employee_id" }) // Self-referencing relationship for manager
    ,
    tslib_1.__metadata("design:type", Object)
], Employee.prototype, "reportingTo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => Employee, (employee) => employee.reportingTo),
    tslib_1.__metadata("design:type", Array)
], Employee.prototype, "reportees", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => organisation_entity_1.Organisation),
    (0, typeorm_1.JoinColumn)({ name: "organisation_id" }),
    tslib_1.__metadata("design:type", Object)
], Employee.prototype, "organisation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", Object)
], Employee.prototype, "statusLookup", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => department_entity_1.Department),
    (0, typeorm_1.JoinColumn)({ name: "department_id" }),
    tslib_1.__metadata("design:type", Object)
], Employee.prototype, "department", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => designation_entity_1.Designation),
    (0, typeorm_1.JoinColumn)({ name: "designation_id" }),
    tslib_1.__metadata("design:type", Object)
], Employee.prototype, "designation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "salutation_lid" }),
    tslib_1.__metadata("design:type", Object)
], Employee.prototype, "salutation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => user_role_entity_1.UserRole, (userRole) => userRole.user),
    (0, typeorm_1.JoinColumn)({ name: "user_id", referencedColumnName: "userId" }),
    tslib_1.__metadata("design:type", Object)
], Employee.prototype, "userRoles", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => org_branch_entity_1.OrgBranch),
    (0, typeorm_1.JoinColumn)({ name: "branch_id" }),
    tslib_1.__metadata("design:type", Object)
], Employee.prototype, "branch", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => org_vertical_entity_1.OrgVertical),
    (0, typeorm_1.JoinColumn)({ name: "vertical_id" }),
    tslib_1.__metadata("design:type", Object)
], Employee.prototype, "vertical", void 0);
exports.Employee = Employee = tslib_1.__decorate([
    (0, typeorm_1.Entity)("employee"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof Partial !== "undefined" && Partial) === "function" ? _a : Object])
], Employee);
